import script from "./ScreenSikvidek.vue?vue&type=script&setup=true&lang=js"
export * from "./ScreenSikvidek.vue?vue&type=script&setup=true&lang=js"

import "./ScreenSikvidek.vue?vue&type=style&index=0&id=174a9515&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-174a9515"]])

export default __exports__